//
// js pour le scroll vers le formulaire
//
let form = document.getElementById('form');

if(form) {
	let href = form.getAttribute('data-href');
	let targetE = href && document.getElementById(href);

	if(targetE) {
		window.scroll({
			behavior: 'smooth',
			top: targetE.offsetTop
		});
	}
}

//
// js pour afficher et rendre obligatoire les champs "Autre (à préciser)" et "Code promotionnel"
//
function questionReponse() {
	let question		= document.getElementById('question');
	let div				= document.getElementById('reponse-d');
	let reponse			= document.getElementById('reponse');

	if(question.value === "Autre (à préciser)" || question.value === "Oui") {
		reponse.setAttribute('required', 'required');
		div.classList.remove('d-none');
	} else {
		reponse.removeAttribute('required');
		div.classList.add('d-none');
	}
}

if(document.getElementById('form') && document.getElementById('question') && document.getElementById('reponse-d') && document.getElementById('reponse')) {
	questionReponse();

	document.getElementById('question').addEventListener('change', function() {
		questionReponse();
	});
}

//
// js pour la validation de la correspondance des e-mails
//
function emailConfirmation() {
	let email			= document.getElementById('email');
	let emailC			= document.getElementById('emailc');

	if(email.value != emailC.value) {
		emailC.setCustomValidity("Veuillez saisir le même e-mail");
	} else {
		emailC.setCustomValidity('');
	}
}

if(document.getElementById('form') && document.getElementById('email') && document.getElementById('emailc')) {
	emailConfirmation();

	document.getElementById('email').addEventListener('change', function() {
		emailConfirmation();
	});

	document.getElementById('emailc').addEventListener('change', function() {
		emailConfirmation();
	});
}

//
// js pour la validation puis l'envoi du formulaire affiché via la disposition unique "Formulaire"
//
let formSubmit			= document.querySelector('form.form button[type=submit]');

formSubmit && formSubmit.addEventListener('click', function(event) {
	event.preventDefault();

	let form			= document.querySelector('form.form');

	if(form.checkValidity()) {
		if(document.querySelector('body').classList.contains('local')) {
			form.submit();
		} else {
			if(document.querySelector('.response')) {
				grecaptcha.ready(() => {
					// public api key
					grecaptcha.execute('6Lc9vV8pAAAAAJY76QYLIZ7H1HuDbXpzeQpkBvKR', {
						action: 'submit'
					}).then(token => {
						document.querySelector('.response').value = token;
						form.submit();
					});
				});
			} else {
				console.error('Input Response is missing');
			}
		}
	} else {
		form.classList.add('was-validated');
	}
});

//
// js pour la validation puis l'envoi du formulaire de recherche présent dans le header
//
let hFormSubmit			= document.querySelector('header form.search button[type=submit]');

hFormSubmit && hFormSubmit.addEventListener('click', function(event) {
	event.preventDefault();

	let form			= document.querySelector('header form.search');

	if(form.checkValidity()) {
		form.submit();
	} else {
		form.classList.add('was-validated');
	}
});

//
// js pour la validation puis l'envoi du formulaire de recherche présent sur la page du moteur de recherche
//
let mFormSubmit			= document.querySelector('main form.search button[type=submit]');

mFormSubmit && mFormSubmit.addEventListener('click', function(event) {
	event.preventDefault();

	let form			= document.querySelector('main form.search');

	if(form.checkValidity()) {
		form.submit();
	} else {
		form.classList.add('was-validated');
	}
});